import React, { useState, useContext } from "react";
import MenuItem from "@material-ui/core/MenuItem";
import Avatar from "@material-ui/core/Avatar/Avatar";
import { Link } from "react-router-dom";
import useStyles from "./styles";
import { __t } from "@core/translation/translation";
import Paper from "@material-ui/core/Paper/Paper";
import MenuList from "@material-ui/core/MenuList/MenuList";
import Typography from "@components/Typography";
import Drawer from "@material-ui/core/Drawer/Drawer";
import withWidth from "@material-ui/core/withWidth/withWidth";
import clsx from "clsx";
import { useUserDispatch, useUserState } from "@features/User/context";
import UserAvatar from "@features/User/components/UserAvatar";
import { Popover } from "@material-ui/core";
import authApi from "@api/auth";
import { notification } from "@core/helper/notificationHelper";
import { getCachedData } from "@core/utils/localStorageManager";
import { Context } from "@features/Wallets/context/context";
import { useHistory } from "react-router-dom";
import { useTheme } from "@material-ui/core";
import Button from "@components/Button";
import { data, data2 } from "./data";
import { SetFormat } from "@features/MarketOrder/components/MarketCard/SelectDigitalCurrency/Functions/format";
import Modal from "../../../Dashboard/Components/DashboardAppBar/Components/EstimatedAssetsComponent/Modal/index";

const UserDropdownMenu = ({ width }) => {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const anchorRef = React.useRef(null);
  const showDrawer = width === "sm" || width === "xs";
  const { state } = useContext(Context);
  const [isShown, setIsShown] = useState(false);
  const theme = useTheme();
  const [openDepositModal, setOpenDepositModal] = useState(false);
  const [openWithdrawModal, setOpenWithdrawModal] = useState(false);
  const token = getCachedData("access_token");
  const user = useUserState();
  const logout = event => {
    authApi
      .logout({
        payload: { token: token }
      })
      .then(data => {
        localStorage.clear();
        window.location.pathname = "/";
      })
      .catch(error => {
        notification(
          __t("Error"),
          "danger",
          error?.message
            ? error.message
            : __t("An error occurred on the server")
        );
      });
    handleClose(event);
  };

  const handleClick = event => {
    setOpenDepositModal(false);
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleOpenModal = val => {
    if (val === "deposit") {
      setOpenDepositModal(true);
    }
    if (val === "withdraw") {
      setOpenWithdrawModal(true);
    }
  };
  const getCoin = () => {
    let walletValue = 0;
    state?.wallet?.map(item => {
      if (item?.currencyName === "IRT") {
        walletValue = item?.availableBalance;
      }
    });
    return walletValue;
  };
  const handleCloseModal = () => {
    setAnchorEl(null);
    setOpenDepositModal(false);
    setOpenWithdrawModal(false);
  };

  const menuItems = (
    <MenuList autoFocusItem={open} className={classes.menuItems}>
      <MenuItem onClick={logout} className={classes.menuItem}>
        <Link>
          <div className={classes.container}>
            <span className={clsx("icon-log-out", classes.icon)} />
            <Typography variant={"xs"}>{__t("signout")}</Typography>
          </div>
        </Link>
      </MenuItem>
    </MenuList>
  );

  return (
    <>
      <div className={classes.avatarWrapper} onClick={handleClick}>
        <UserAvatar />
        <span
          ref={anchorRef}
          className={classes.avatarArrow}
          showUserName={false}
          editable={false}
        >
          <i className={anchorEl ? "icon-x" : "icon-chevron-down"}></i>
        </span>
      </div>

      {(!showDrawer && (
        <Popover
          open={open}
          className={classes.root}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorReference="anchorPosition"
          anchorPosition={{ top: 80, left: 60 }}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left"
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "left"
          }}
        >
          {/* <Paper className={classes.root} elevation={0}>
            {menuItems}
          </Paper> */}
          <div className={classes.Exit}>
            <div className={classes.title}>
              <div>
                <Typography variant="xs" color="secondary.tint60">
                  {__t("estimated assets")}
                </Typography>
                <Typography variant="sm" color="secondary.main">
                  {SetFormat(getCoin())}
                </Typography>
              </div>
              <Typography variant="2xs" color="secondary.tint60" component="p">
                {__t("toman")}
              </Typography>
              <div className={classes.Buttons}>
                <Link to="/wallet/wallets-list">
                  <Button
                    variant="containd"
                    color="default"
                    size="small"
                    onClick={handleClose}
                    className={clsx(classes.headerBtn, classes.wallets)}
                  >
                    <i className="icon-chevron-left" />
                    {__t("wallets")}
                  </Button>
                </Link>
                {data2.map(item => (
                  <div key={item.id}>
                    <Button
                      variant="containd"
                      color={item.color}
                      size="small"
                      onClick={() => handleOpenModal(item.name)}
                      className={clsx(
                        classes.headerBtn,
                        item.id === 0 ? classes.withdraw : classes.dapasit
                      )}
                    >
                      {item.title}
                      {item.icon && <i className={item.icon} />}
                    </Button>
                    <Modal
                      handleClose={handleCloseModal}
                      open={
                        item.name === "withdraw"
                          ? openWithdrawModal
                          : openDepositModal
                      }
                      alertTitle={item.alertTitle}
                      alertSubTitle={item.alertSubTitle}
                      type={item.name}
                    />
                  </div>
                ))}
              </div>
            </div>
            <div className={classes.Menu}>
              {data.map(item => (
                <Link to={item.path} key={item.id}>
                  <Button
                    variant="text"
                    color="default"
                    size="large"
                    onClick={handleClose}
                    className={
                      user?.user?.role !== "TWO"
                        ? classes.btn
                        : item.id === 3
                        ? classes.nullBtn
                        : classes.btn
                    }
                    onMouseEnter={() => setIsShown(item.name)}
                    onMouseLeave={
                      item.name === isShown
                        ? () => setIsShown(false)
                        : () => setIsShown(false)
                    }
                  >
                    <i className="icon-chevron-left" />
                    <span>{item.title}</span>
                    <i
                      className={
                        isShown === item.name ? item.iconFill : item.icon
                      }
                    />
                  </Button>
                </Link>
              ))}
            </div>
            <Button
              variant="text"
              color="default"
              size="large"
              onClick={logout}
              className={classes.signOut}
              autoFocusItem={open}
            >
              <span>{__t("signout")}</span>
              <i className="icon-log-out" />
            </Button>
          </div>
        </Popover>
      )) || (
        <Drawer anchor={"right"} open={open} onClose={handleClose}>
          {menuItems}
        </Drawer>
      )}
    </>
  );
};

export default withWidth()(UserDropdownMenu);
